import type { Attachment } from './agents/types';
import { shortId } from './utils';

export function fileToAttachment(file: File): Attachment {
  const isImage = file.type.startsWith('image/');
  return {
    id: shortId('att'),
    kind: isImage ? 'image' : 'file',
    name: file.name,
    size: file.size,
    mime: file.type || undefined,
  };
}

export async function filesToAttachments(files: FileList | File[]): Promise<Attachment[]> {
  const arr = Array.from(files);
  return arr.map(fileToAttachment);
}

export function folderEntriesFromInput(files: FileList): Attachment[] {
  // <input webkitdirectory> gives us files with webkitRelativePath. Group them by top-level folder.
  const byFolder = new Map<string, number>();
  for (const f of Array.from(files)) {
    const rel = (f as File & { webkitRelativePath?: string }).webkitRelativePath ?? f.name;
    const top = rel.split('/')[0];
    byFolder.set(top, (byFolder.get(top) ?? 0) + 1);
  }
  const out: Attachment[] = [];
  for (const [name, count] of byFolder) {
    out.push({ id: shortId('att'), kind: 'folder', name: `${name} (${count} files)` });
  }
  return out;
}

export function filesFromClipboard(e: ClipboardEvent): File[] {
  const items = e.clipboardData?.items;
  if (!items) return [];
  const out: File[] = [];
  for (const item of Array.from(items)) {
    if (item.kind === 'file') {
      const f = item.getAsFile();
      if (f) out.push(f);
    }
  }
  return out;
}
